/* ログインID変更 */
import React, { useState, useEffect } from 'react';
import Block from '../molecules/Block';
import Text from '../molecules/Text';
import axios from '../axios';
import { Row, Col, Button } from 'react-bootstrap';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { convertLine } from '../Convert';
import RowJustifyButton from '../molecules/RowJustifyButton';
import { jumpUrl } from '../Common';
import { http_status } from '../Const';
import RowCenterButton from '../molecules/RowCenterButton';
import { createRoot } from 'react-dom/client';

const LoginIdChange: React.FC = () => {
  // ログインID情報のState
  // ログインID
  const [login_id, setLoginId] = useState('');
  // ログインID(確認)
  const [login_id_confirmation, setLoginIdConfirmation] = useState('');
  // ワンタイムパスワード
  const [onetime_password, setOneTimePassword] = useState('');

  // メールアドレスメッセージ
  const [mail_address_message, setMailAddressMessage] = useState([]);
  // ワンタイムパスワードメッセージ
  const [onetime_password_message, setOneTimePasswordMessage] = useState([]);

  const [status_code, setStatusCode] = useState(0);
  // Ajax通信中フラグ
  const [is_connecting, setIsConnecting] = useState(false);
  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  // 注意文言
  const [attention_text, setAttentionText] = useState('');
  // ワンタイムパスワード入力欄
  const [show_one_time_password, setShowOneTimePassword] = useState(false);
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    getAttentionText();
  }, []);

  /**
   * 注意文言を取得する
   */
  const getAttentionText = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('/login_id/attention_text');
      setAttentionText(response.data.attention_text);
    } catch (error) {
      console.error;
    } finally {
      setIsLoading(false);
    }
  };

  // メールアドレス変更ボタンのクリックイベントを定義
  const handleLoginIdChange = () => {
    // ログイン情報をStateへセット
    // 結果表示ボックスに適用するCSSクラス名
    const login_id_info = {
      login_id: login_id,
      login_id_confirmation: login_id_confirmation,
      onetime_password: onetime_password,
    };
    const loginIdChange = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);
        // 成功
        const response = await axios.post('/login_id/validate', login_id_info);
        // ログインID変更完了画面へ遷移
        location.replace(`${process.env.MIX_MOCK_URL}/login_id/complete`);
        setIsConnecting(false);
      } catch (error) {
        // 失敗
        console.log(error.response.data.message);
        jumpUrl(error.response.data.url);
        setOneTimePasswordMessage(error.response.data.message);
        setStatusCode(error.response.status);
        setIsConnecting(false);
      } finally {
        // ローディング画面非表示
        setIsLoading(false);
        setMailAddressMessage([]);
      }
    };
    // ログインID変更処理
    loginIdChange();
  };

  // ワンタイムパスワード送信をクリック
  const handleSendOneTimePassword = () => {
    const login_id_info = {
      login_id: login_id,
      login_id_confirmation: login_id_confirmation,
    };
    const sendOnetimePassword = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);

        const response = await axios.post(
          `${location.origin}${process.env.MIX_MOCK_URL}/login_id/send_onetime_passsword`,
          login_id_info
        );
        setMailAddressMessage(response.data.message);
        setStatusCode(response.status);
        setShowOneTimePassword(true);
        setTimeout(() => focusOneTimePassword(), 10);
      } catch (error) {
        // 失敗
        console.log(error.response.data.message);
        setMailAddressMessage(error.response.data.message);
        setStatusCode(error.response.status);
      } finally {
        setIsConnecting(false);
        // ローディング画面非表示
        setIsLoading(false);
        setOneTimePasswordMessage([]);
      }
    };
    // ワンタイムパスワード発行
    sendOnetimePassword();
  };
  /**
   * 戻るボタンをクリックする
   */
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };

  /**
   * ワンタイムパスワードテキストボックスにフォーカス
   */
  const focusOneTimePassword = () => {
    document.getElementById('onetime-password')?.focus();
  };

  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="ログインID変更"
        content={
          <>
            <Row className="annotation newline">
              {
                '新しいメールアドレスを入力してください。\n入力したメールアドレスにワンタイムパスワードを送信します。'
              }
            </Row>
            <div className="mt-3"></div>
            <div>
              <Text
                id="email"
                label="メールアドレス"
                value={login_id}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setLoginId(event.target.value)
                }
                disabled={show_one_time_password}
                maxlength={200}
              />
            </div>
            <div className="mt-3">
              <Text
                id="email-confirm"
                label="メールアドレス（確認）"
                value={login_id_confirmation}
                placeholder=""
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setLoginIdConfirmation(event.target.value)
                }
                disabled={show_one_time_password}
                maxlength={200}
              />
            </div>
            {mail_address_message.length > 0 && (
              <Row className="d-flex align-items-center justify-content-center mt-3">
                <Col></Col>
                <Col
                  md={9}
                  className={`pt-3 ${
                    status_code === http_status.ok ? 'alert-success' : 'alert-danger'
                  }
                `}
                >
                  <ul>
                    {mail_address_message.map((mail_address_message, index) => {
                      return <li key={index}>{mail_address_message}</li>;
                    })}
                  </ul>
                </Col>
              </Row>
            )}
            {/* 注意文言 */}
            <Row
              className="annotation mt-3"
              dangerouslySetInnerHTML={{ __html: convertLine(attention_text) }}
            />
            <div className="mt-3">
              <RowJustifyButton>
                <div className="col col-lg-2">
                  <Button
                    variant="main-color"
                    onClick={handleClickReturn}
                    size="lg"
                    className="lg mb-3"
                  >
                    戻る
                  </Button>
                </div>
                <div className="col-md-auto"></div>
                <div className="col col-lg-2">
                  <Button
                    variant="main-color"
                    onClick={handleSendOneTimePassword}
                    size="lg"
                    className="lg"
                  >
                    メール送信
                  </Button>
                </div>
              </RowJustifyButton>
            </div>
            {show_one_time_password && (
              <div>
                <Row className="annotation newline mt-3">
                  {`ワンタイムパスワードを発行しました。\nメールに届いた「4文字の数字」を入力して、メールアドレスの変更を完了してください。`}
                </Row>
                <div className="mt-3">
                  <Text
                    id="onetime-password"
                    label="ワンタイムパスワード"
                    value={onetime_password}
                    placeholder=""
                    handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                      setOneTimePassword(event.target.value)
                    }
                    disabled={false}
                  />
                </div>
                <Row className="annotation newline mt-3">
                  {`ワンタイムパスワードの有効期限は5分です。\nワンタイムパスワードが届かない場合、戻るのボタンを押して最初から操作してください。`}
                </Row>
                <RowCenterButton>
                  <Button
                    variant="main-color"
                    onClick={handleLoginIdChange}
                    size="lg"
                    className="lg  mb-3"
                  >
                    メールアドレス変更
                  </Button>
                </RowCenterButton>
                <br />
              </div>
            )}
            {onetime_password_message.length > 0 && (
              <Row className="d-flex align-items-center justify-content-center mt-3">
                <Col></Col>
                <Col
                  md={9}
                  className={`pt-3 ${
                    status_code === http_status.ok ? 'alert-success' : 'alert-danger'
                  }
                `}
                >
                  <ul>
                    {onetime_password_message.map((onetime_password_message, index) => {
                      return <li key={index}>{onetime_password_message}</li>;
                    })}
                  </ul>
                </Col>
              </Row>
            )}
          </>
        }
      />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};
const container = document.getElementById('common-login-id-change');
if (container) {
  const root = createRoot(container);
  root.render(<LoginIdChange />);
}
